"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InvoiceList = _interopRequireDefault(require("./InvoiceList.vue"));
var _WhitelistManagement = _interopRequireDefault(require("./WhitelistManagement.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "发票列表",
  components: {
    invoiceList: _InvoiceList.default,
    whitelistManagement: _WhitelistManagement.default
  },
  data: function data() {
    return {
      activeName: 'blue',
      editTabs: [],
      tabIndex: 0
    };
  }
};